/**
 * Status-based row tint for approval tables (admin/approver side).
 * Uses semantic CSS classes so fixed/sticky columns get matching opaque backgrounds.
 */
export function approvalRowClass(status?: string | null): string {
  switch (status) {
    case 'Approved':
      return 'leap-row-status-approved'
    case 'Rejected':
      return 'leap-row-status-rejected'
    case 'Pending':
      return 'leap-row-status-pending'
    default:
      return ''
  }
}

/** Transporter upload table — Pending uses a muted grey tint instead of amber. */
export function transporterRowClass(status?: string | null): string {
  switch (status) {
    case 'Approved':
      return 'leap-row-status-approved'
    case 'Rejected':
      return 'leap-row-status-rejected'
    case 'Pending':
      return 'leap-row-status-transporter-pending'
    default:
      return ''
  }
}
